import { SERVICEVALUE_SERVICE } from "@/services/serviceValue.service.js";

const state = {postServiceValueOutput: false, getServiceValueOutput: {}, putServiceValueOutput: false, getServiceValueDetailsOutput: {}, deleteServiceValueOutput: false};

const actions = {
    //Service to create Key Values
    postServiceValue({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postKeyValueRequest');

        SERVICEVALUE_SERVICE.postServiceValue(input)
            .then(
                output => {
                    commit('postKeyValueSuccess', output);
                },
                error => {
                    commit('postKeyValueFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated Key values
    getServiceValue({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getKeyValuesRequest');

        SERVICEVALUE_SERVICE.getServiceValue(queryParams)
            .then(
                output => {
                    commit('getKeyValuesSuccess', output);
                },
                error => {
                    commit('getKeyValuesFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to update key values
    putServiceValue({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putKeyValueRequest');

        SERVICEVALUE_SERVICE.putServiceValue(input)
            .then(
                output => {
                    commit('putKeyValueSuccess', output);
                },
                error => {
                    commit('putKeyValueFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get key value details
    getServiceValueDetails({ dispatch, commit }, uniqueIdentifier) {
        dispatch('alert/clear', null, { root: true });
        commit('getKeyValueDetailsRequest');

        SERVICEVALUE_SERVICE.getServiceValueDetails(uniqueIdentifier)
            .then(
                output => {
                    commit('getKeyValueDetailsSuccess', output);
                },
                error => {
                    commit('getKeyValueDetailsFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete key values
    deteleServiceValueById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteKeyValueByIdRequest');

        SERVICEVALUE_SERVICE.deteleServiceValueById(id)
            .then(
                output => {
                    commit('deleteKeyValueByIdSuccess', output);
                },
                error => {
                    commit('deleteKeyValueByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    //postServiceValue
    postKeyValueRequest(state) {
        state.postServiceValueOutput = null;
    },
    postKeyValueSuccess(state, output) {
        state.postServiceValueOutput = true;
    },
    postKeyValueFailure(state) {
        state.postServiceValueOutput = false;
    },

    //getServiceValues
    getKeyValuesRequest(state) {
    },
    getKeyValuesSuccess(state, output) {
        state.getServiceValueOutput = output;
    },
    getKeyValuesFailure(state) {
        state.getServiceValueOutput = false;
    },

    //putServiceValue
    putKeyValueRequest(state) {
        state.putServiceValueOutput = null;
    },
    putKeyValueSuccess(state, output) {
        state.putServiceValueOutput = true;
    },
    putKeyValueFailure(state) {
        state.putServiceValueOutput = false;
    },

    //getServiceValueDetails
    getKeyValueDetailsRequest(state) {
    },
    getKeyValueDetailsSuccess(state, output) {
        state.getServiceValueDetailsOutput = output;
    },
    getKeyValueDetailsFailure(state) {
        state.getServiceValueDetailsOutput = false;
    },

    //deteleServiceValueById
    deleteKeyValueByIdRequest(state) {
        state.deleteServiceValueOutput = null;
    },
    deleteKeyValueByIdSuccess(state, output) {
        state.deleteServiceValueOutput = true;
    },
    deleteKeyValueByIdFailure(state) {
        state.deleteServiceValueOutput = false;
    },
};

export const serviceValue = {
    namespaced: true,
    state,
    actions,
    mutations
};